import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/Gallery.css'; // Import Gallery CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS for fonts
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; 

import GallerySec from './GallerySec'; // Ensure the path is correct

const HeroGallery = () => {
  return (
    <>
    <Helmet>
          <title>RCS Logistics Philippines - Gallery</title>
          <meta name="description" content="Partner with RCS Logistics Philippines to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta name="keywords" content="logistics, transportation, RCS Logistics, Philippines, forwarding, brokerage, sea land service, freight forwarding, international shipping, supply chain management, cargo handling, customs brokerage, project cargo, warehousing, import export, air freight, ocean freight, domestic transportation, logistics services" />
          <meta property="og:url" content="https://rcslogisticsph.com/gallery" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="RCS Logistics Philippines - Moving You Forward" />
          <meta property="twitter:description" content="Partner with the best to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta property="twitter:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
        </Helmet>
      <section
        id="gallery"
        className="gallery-hero-section d-flex align-items-center"
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <button 
                disabled 
                className="gallery-hero-button mb-4"
              >
                SEE HOW WE OPERATE
              </button>
              <h1 className="text-white mb-4 gallery-hero-title">
                Our Work Gallery
              </h1>
              <p className="text-white-50 fs-5 gallery-hero-subtitle">
                Explore our successful logistics operations and see how we deliver excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Include the other sections */}
      <GallerySec />
    </>
  );
};

export default HeroGallery;
